import { createFileRoute, redirect } from '@tanstack/react-router';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';

// Backward-compat: il form prodotto vive ora sotto Anagrafica.
export const Route = createFileRoute('/protected/_layout/products/_layout/new')(
  {
    beforeLoad: () => {
      throw redirect({ to: `${PROTECTED}${REGISTRY}/products/new` });
    },
  }
);
